export default {
    getDynamicForm: function (form$) {

        //knowing the vueform from$, try to find the dynamic form
        if (form$?.value?.$parent)
            return form$.value.$parent;

        return null;

    },
    //try to find the schema of the named form field
    findChildSchemaAndPath: function (form, locationGroupFullName, formElementName) {

        const nullResult = {schema: null, path: null};

        //find the first formElementName under the locationGroupFullName
        const fullPathMatches = form.flatTree.filter(x => x.startsWith(locationGroupFullName) && x.endsWith(`.${formElementName}`));

        //no matches
        if(fullPathMatches.length===0){
            return nullResult;
        }

        const firstMatch = fullPathMatches[0];

        //walk the schema by this path
        const pathElements = firstMatch.split('.');
        let current = form.schema;
        for (let nodeIndex in pathElements) {
            const nodeName = pathElements[nodeIndex];

            //if this is the last element we are finding, there is no schema under it, it is the thing you want
            if(nodeIndex==pathElements.length-1 && nodeName==formElementName){
                current = current[nodeName];
            } else{
                current = current[nodeName]?.schema;
            }

            //if for some reason something doesn't work and we don't find part of the path report the issue
            if(current == null){
                console.log(`VPF: fh: failed to find ${formElementName} by ${firstMatch}`);
                return nullResult;
            }

        }


        return {schema: current, path: firstMatch};
       
    }
}